<template>
  <div class="main-container" v-loading="loading">
    <h2 class="main-title">年度预算调整申请</h2>
    <div class="horizon-line"></div>
    <div class="info-content">
      <h3 class="minor-title">发起人信息</h3>
      <user-table :user="submitParms" ></user-table>
      <h3 class="minor-title "> <span class="danger-text">*</span> 流程标题 
      </h3>
      <el-input v-model.trim="submitParms.title" maxlength="50" placeholder="请输入流程标题" clearable></el-input>
      <start-form
        :ext1Auth="ext1Auth"
        :firstDeptList="firstDeptList"
        :budgetTypeList="budgetTypeList"
        @setFileList="setFileList"
        class="margin-top-big"
        :submit-parms="submitParms"
        @submitParms="setSubmitParms"
      ></start-form>
      <div class="submit">
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 年度预算调整申请发起页
 * V3.6.2：按角色控制 ext1 可选范围；明细校验/提交使用 shareTypeNo 替代事业部
 */
import { awaitWrapper, sleep } from "@/common/utils/assist.js"; //
import {
  getShareTypeLabel,
  defaultShareTypeNo,
} from "@/modules/yearBudget/constants/shareType.js"
import UserTable from "@/common/components/userTable.vue"; // 发起人信息和提交人信息表格
import StartForm from "./components/StartFormYear.vue";
import plus from 'library/functions/plus'
import {
    getInfo, // 获取拥护user-table信息
    // queryListCount, // 获取部门年度调整次数
    addYearAdjust, // 新增年度预算
    getYearAdjustDetail, // 年度预算调整详情
    getOriTree, // 传7获取预算大类
    getEhrFirstDepts, // 获取ehr一级部门
    getAdjustFirstDeptList, // 获取调整的一级部门
} from "./request";
export default {
  components: {
    UserTable, // 发起人信息
    StartForm, // 发起或驳回后重新填报的表单部分
  },
  props: {
    type: String, // 1:月度资金计划调整申请 2:年度资金计划调整申请
  },
  data() {
    return {
        // title: "", // 流程标题
        loading: false, // 全屏加载中
        // listCount: null, // 已调整次数
        submitParms: {
            "alterYear": "", // 调整年份
            "budgetType": [], // 预算大类
            "title": "年度预算调整流程",
            "msg":"", // 备注 // 
            "phone": "", // 手机号
            "email": "", 
            "userId":"",
            "userCode":"",
            "userName": "",
            "ext1": "1", // 
            "deptCode": null, // 
            deptCodeList: [],
            "deptName": "", // 
            "ext3": "1", // 紧急情况 // 默认
            // "expectedCompletionDate":"", // 期待完成日期
            "attachment": null, // TODO file=> attachment 附件 
            "detailList": [
                [{}, {}],
                // {
                // },
                // {
                // }
                // {
                //   "firstDeptId": 493, // ?
                //   "firstDeptName": "重庆分校",
                //   "subjectsCatName": "dalei",
                //   "subjectsTypeName": "leixing", 
                //   "year": "2023",
                //   "month": "08",
                  // "adjustAmount": "1000",
                  // "budgetAmount": "2000",
                  // "adjustBeforeAmount": 3000,
                  // "budgetImplementedAmount": 4000,
                  // "adjustAfterRemainAmount": 5000,
                  // "budgetAdjustType": "1"
                // }
                // {
                // "firstDeptId": null,
                // "firstDeptName": "",
                // "subjectsCatName": "",
                // "subjectsTypeName": "",
                // "year": "",
                // "month": "",
                // "adjustAmount": "",
                // "budgetAmount": "",
                // "adjustBeforeAmount": null,
                // "budgetImplementedAmount": null,
                // "adjustAfterRemainAmount": null,
                // "budgetAdjustType": ""
                // }
            ]
        },
        firstDeptList: [],
        budgetTypeList: [], // 预算大类
        fileListStr: null, // 附件字符串
        ext1Auth: [], // V3.6.2：预算调整类型权限，由 setExt1Auth 按角色写入，传给 StartFormYear 过滤 ext1 下拉
    };
  },
  created() {
    // 初始化信息
    this.getOriInfo(7) // 获取预算大类
    this.getAdjustFirstDeptList()
    this.getInfo();
    this.setExt1Auth() // 设置预算调整类型权限
    if( this.$route.query.id ) {
      this.getYearAdjustDetail()
    }
  },
  methods: {
    /**
     * V3.6.2：按角色设置可调整类型（ext1Auth）及默认 ext1
     * - roleId 15（总部预算负责人）：仅预算外 ext1=5，隐藏相同预算大类(1)、弹性授予(3)
     * - roleId 18（一级部门预算接口人）：默认 ext1=2，可选 2/5
     */
    setExt1Auth() {
      // 15 总部预算负责人
      // 18 一级部门预算接口人
      // console.log(this.$store.state.userInfo)
      if (this.$store.state.userInfo && this.$store.state.userInfo.curRole && this.$store.state.userInfo.curRole.roleId) {
        if (this.$store.state.userInfo.curRole.roleId == 15) {
          this.ext1Auth =  ['5'] // V3.6.2 隐藏相同预算大类、弹性授予，仅预算外调整
          this.submitParms.ext1 = '5'
        } else if (this.$store.state.userInfo.curRole.roleId == 18) {
          this.submitParms.ext1 = '2'
          this.ext1Auth =  ['2', '5'] // 相同预算一级部门调整
        } else {
          this.submitParms.ext1 = null
        }
      } else {
        this.submitParms.ext1 = null
      }
    },
    async getOriInfo(type) { // 获取预算大类
        this.loading = true
        let [, res] = await awaitWrapper(getOriTree({
            dataType: type
        }))
        this.loading = false
        if (!res || res.code != 0) {
            return
        }
        if (type == 7) {
            this.budgetTypeList = res.data.tree || []
        }
    },
    async getAdjustFirstDeptList() {
        this.loading = true
        let [, res] = await awaitWrapper(getAdjustFirstDeptList())
        this.loading = false
        if (res && res.code == 0) {
          this.firstDeptList = (res.data || []).map(item => {
              return {
                  ...item,
                  dicId: item.id,
                  dicName: item.name,
                  ehrFirstId: item.id
              }
          })
        }
    },

    async getYearAdjustDetail () {
        var AVAILABLE_EXT1 = ['2', '5']
        let [, res] = await awaitWrapper(getYearAdjustDetail({ id: this.$route.query.id }))
        if (!(res && res.data)) return
        var copiedExt1 = res.data.ext1 == 4 ? '5' : String(res.data.ext1)
        var isExt1Allowed = AVAILABLE_EXT1.includes(copiedExt1) &&
          (!this.ext1Auth.length || this.ext1Auth.includes(copiedExt1))
        // 保留字段：title / ext3 / attachment / msg 始终复制
        this.submitParms.title = res.data.title
        this.submitParms.msg = res.data.msg
        this.submitParms.ext3 = res.data.ext3
        this.$set(this.submitParms, 'attachment', res.data.attachment || '[]')
        if (!isExt1Allowed) {
          // 透传复制年份（子组件校验是否在可选列表，不在则取默认最新年）
          var firstDetail = (res.data.detailsList && res.data.detailsList[0]) ||
            (res.data.grantDetail && res.data.grantDetail[0]) || {}
          this.submitParms.alterYear = firstDetail.year || ''
          this.clearEditFlags()
          this.$store.commit('SET_IS_RESET_TO_DEFAULT', true)
          return
        }
        this.submitParms.ext1 = copiedExt1
        this.submitParms.detailList = res.data.detailsList
        this.submitParms.grantDetail = res.data.grantDetail
        this.clearEditFlags()
        if (this.submitParms.ext1 === '3') {
          this.submitParms.alterYear = res.data.grantDetail[0].year
          this.submitParms.grantDetail = (this.submitParms.grantDetail || []).map(item=>{
            return {
              ...item,
              grantedMonth: this.formatDateToYearMonth(item.grantedMonth),
              pendingGrantedMonth: this.formatDateToYearMonth(item.pendingGrantedMonth),
            }
          })
          this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE3', true)
        } else if (this.submitParms.ext1 === '1') {
          this.submitParms.alterYear = res.data.detailsList[0].year
          this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE1', true)
        } else if (this.submitParms.ext1 === '5') {
          this.submitParms.alterYear = res.data.detailsList[0].year
          this.submitParms.detailList = [res.data.detailsList]
          this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE5', true)
        } else if (this.submitParms.ext1 === '2') {
          this.submitParms.alterYear = res.data.detailsList[0].year
          this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE2', true)
        }
    },
    clearEditFlags() {
      this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE1', false)
      this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE2', false)
      this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE3', false)
      this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE5', false)
    },
    // 添加日期格式转换函数
    formatDateToYearMonth(dateStr) {
        if (!dateStr) return '';
        const match = dateStr.match(/(\d{4})年(\d{1,2})月/);
        if (match) {
            const year = match[1]
            const month = match[2] // 确保月份是两位数
            return `${year}_${month}`;
        }
        return '';
    },
    // setDetailListByEdit(data) { // 编辑阶段设置代码
    //   if (String(data.ext1) === '3') {
    //     this.setDetailListByExtType3(data.grantDetail)
    //   } else {
    //     this.submitParms.detailList = data.detailsList
    //   }
    // },
    // setDetailListByExtType3(successList) {
    //   const detailList = []
    //   const detailObj = {}
    //   this.tabList = [];
    //   let tabId = 1;
    //   // 根据一级部门合并想要的数据。谢谢
    //   successList.forEach(item => {
    //       if (detailObj[item.firstDeptId]) {
    //           detailObj[item.firstDeptId].push({
    //             ...item,
    //             tabId: detailObj[item.firstDeptId][0].tabId
    //           })
    //       } else {
    //           tabId++
    //           detailObj[item.firstDeptId] = [{
    //             ...item,
    //             tabId
    //           }]
    //       }
    //   })
    //   Object.keys(detailObj).forEach((key, index) => {
    //       detailList.push(detailObj[key])
    //       this.tabList.push({
    //         dicId: detailObj[key][0].tabId,
    //         dicName: '调整明细'
    //       })
    //   })
    //   this.elasticityColumnDataByDetail = elasticityColumnDataByDetail
    //   this.submitParms.detailList = detailList
    // },
    // 设置参数
    setSubmitParms(params) { 
        this.submitParms = JSON.parse(JSON.stringify(params))
    },
    setFileList(params) {
        this.fileListStr = JSON.stringify(params)
    },
    // 获取初始化信息
    async getInfo() {
      const userInfo = this.$store.state.userInfo
      let [, res] = await awaitWrapper(getInfo({ staffId: userInfo.id }))
      if (res && res.code === 0) {
        this.submitParms.phone = res.data.mobile
        this.submitParms.email = res.data.workEmail
        this.submitParms.userId = res.data.id
        this.submitParms.userCode = res.data.staffNo
        this.submitParms.userName = res.data.chinseName
        this.submitParms.deptCode = res.data.oneNodeId
        this.submitParms.deptName = res.data.oneNodeName
        this.submitParms.userName = res.data.chinseName
        // 自动组装title，组装格式：一级部门名称+年度预算调整流程
        if( !this.$route.query.id) {
          this.submitParms.title = '年度预算调整流程'
        }
        // 获取部门年度调整次数
        // this.queryListCount();
      }
    },
    handleValidateExt5DetailList() {
      // V3.6.2 预算外调整：唯一性/必填维度含 shareTypeNo，不再校验事业部
      try {
      const detailList = (this.submitParms.detailList || []).flat()
      let errmsg = null
      const repestIdList = []
      if (this.$store.state.userInfo.curRole.roleId == 18) { // 一级预算接口负责人，如何使用
        for (let i = 0; i < detailList.length; i++) {
          if (detailList[i].firstDeptId && !repestIdList.includes(detailList[i].firstDeptId)) {
            repestIdList.push(detailList[i].firstDeptId)
          }
        }
      }
      // console.log('repeatIndex', repeatIndex)
      if (repestIdList.length > 1) {
        this.$message({
          message: "一次只能调整一个部门",
          type: "warning",
        });
        return false;
      }
      for (let i = 0; i < detailList.length; i++) {
        if (String(detailList[i].adjustAmount) === '0') {
          errmsg = "调整金额不允许为0"
        } else if (!detailList[i].adjustAmount) {
          errmsg = "调整金额不允许为空"
        }
        if (!detailList[i].cycleMonth) {
            errmsg = "缺少预算周期"
        }
        if (!detailList[i].shareTypeNo) {
            errmsg = "缺少是否待分摊"
        }
        if (!detailList[i].subjectsTypeId) {
            errmsg = "缺少预算类型"
        }
        if (!detailList[i].subjectsCatId) {
            errmsg = "缺少预算大类"
        }
        if (!detailList[i].firstDeptId) {
            errmsg = "缺少预算一级部门"
        }
        if (String(this.submitParms.ext1) === '5') {
          if (errmsg) {
              const index = i + 1
              this.$message({
                  message: "预算调整明细第" + index + "行" + errmsg,
                  type: "warning",
              });
              return false;
          }
        }
        
      }
      
      
      for (let i = 0; i < this.submitParms.detailList.length && ['1', '2'].includes(this.submitParms.ext1); i++) {
          const currDetailList = this.submitParms.detailList[i]
          const checkedName = this.budgetTypeList.find(item=> String(item.dicId) === String(currDetailList[0].subjectsCatId)).dicName
          const currAmount = (currDetailList || []).reduce((pre, curr)=>{return plus(pre, curr.adjustAmount)}, 0)
          
          if (String(currAmount) !== '0') {
            this.$message({
                message: checkedName + "调整金额合计必须为0",
                type: "warning",
            });
            return false
          }
        }
        return true
      } catch (error) {
        console.log('error', error)
      }
    },
    handleValidateExt3DetailList() { // 弹性验证
      try {
      const detailList = (this.submitParms.detailList || [])
      let errmsg = null
      for (let i = 0; i < detailList.length; i++) {
        const currDetailList = detailList[i]
        if (!Array.isArray(currDetailList)) {
          errmsg = '调整明细数据格式错误'
          this.$message({
                message: errmsg,
                type: "warning",
            });
          return false
        }
        let adjustGrantedAmount = 0
        let adjustPendingGrantedAmount = 0
        for (let j = 0; j < currDetailList.length; j++) {
          const currDetailItem = currDetailList[j]
          console.log('currDetailItem', currDetailItem) 
          console.log('currDetailItem', currDetailItem) 
          if (!currDetailItem.adjustGrantedAmount && !currDetailItem.adjustPendingGrantedAmount) {
            errmsg = '已授予调整金额和待授予调整金额至少填写一个'
          }
          if (!currDetailItem.grantedMonth && !currDetailItem.pendingGrantedMonth) {
            errmsg = '缺少已授予调整月份或待授予调整月份'
          }
          if (!currDetailItem.budgetCycle) {
            errmsg = '缺少预算周期'
          }
          if (!currDetailItem.businessUnitId) {
            errmsg = '缺少事业部'
          }
          if (!currDetailItem.subjectsTypeId) {
            errmsg = '缺少预算类型'
          }
          if (!currDetailItem.subjectsCatId) {
            errmsg = '缺少预算大类'
          }
          if (!currDetailItem.firstDeptId) {
            errmsg = '缺少预算一级部门'
          }
          adjustGrantedAmount = plus(adjustGrantedAmount, currDetailItem.adjustGrantedAmount || 0)
          adjustPendingGrantedAmount = plus(adjustPendingGrantedAmount, currDetailItem.adjustPendingGrantedAmount || 0)
          if (errmsg) {
            const tabIndex = i + 1
            const rowIndex = j + 1
            this.$message({
              message: "调整明细" + tabIndex + "第" + rowIndex + "行" + errmsg,
              type: "warning",
            });
            return false;
          }
        }
        if (plus(adjustGrantedAmount, adjustPendingGrantedAmount) !== 0) {
          this.$message({
              message: "调整明细" + (i + 1) + "已授予调整金额和待授予调整金额合计必须为0",
              type: "warning",
          });
          return false;
        }
      }
      // for (let i = 0; i < detailList.length; i++) {
      //   if (String(detailList[i].adjustAmount) === '0') {
      //     errmsg = "调整金额不允许为0"
      //   } else if (!detailList[i].adjustAmount) {
      //     errmsg = "调整金额不允许为空"
      //   }
      //   if (!detailList[i].cycleMonth) {
      //       errmsg = "缺少预算周期"
      //   }
      //   if (!detailList[i].businessUnitId) {
      //       errmsg = "缺少事业部"
      //   }
      //   if (!detailList[i].subjectsTypeId) {
      //       errmsg = "缺少预算类型"
      //   }
      //   if (!detailList[i].subjectsCatId) {
      //       errmsg = "缺少预算大类"
      //   }
      //   if (!detailList[i].firstDeptId) {
      //       errmsg = "缺少预算一级部门"
      //   }
      //   if (String(this.submitParms.ext1) === '1') {
      //     const checkedName = this.budgetTypeList.find(item=> String(item.dicId) === String(detailList[i].subjectsCatId)).dicName
      //     if (errmsg) {
      //         const index = i + 1
      //         this.$message({
      //             message: "预算调整明细" + checkedName + "第" + index + "行" + errmsg,
      //             type: "warning",
      //         });
      //         return false;
      //     }
      //   } else if (String(this.submitParms.ext1) === '2') {
      //     const checkedName = this.firstDeptList.find(item=> String(item.dicId) === String(detailList[i].firstDeptId)).dicName
      //     if (errmsg) {
      //         const index = i + 1
      //         this.$message({
      //             message: "预算调整明细" + checkedName + "第" + index + "行" + errmsg,
      //             type: "warning",
      //         });
      //         return false;
      //     }
      //   } else if (String(this.submitParms.ext1) === '5') {
      //     if (errmsg) {
      //         const index = i + 1
      //         this.$message({
      //             message: "预算调整明细第" + index + "行" + errmsg,
      //             type: "warning",
      //         });
      //         return false;
      //     }
      //   }
        
        
      //   // if( String(this.submitParms.ext1) === '1' && plus(this.submitParms.detailList[0].adjustAmount, this.submitParms.detailList[1].adjustAmount)!==0) {
      //   //   this.$message({
      //   //       message: checkedName + "调整金额合计必须为0",
      //   //       type: "warning",
      //   //   });
      //   //   return false; 
      //   // }

      // }
      return true
      } catch (error) {
        console.log('error', error)
      }
    },
    validateDetailList() {
      if (['5'].includes(String(this.submitParms.ext1))) {
        return this.handleValidateExt5DetailList()
      } else if (['1', '2'].includes(String(this.submitParms.ext1))) {
        return this.handleValidateExt1And2DetailList()
      } else if (String(this.submitParms.ext1) === '3') {
        return this.handleValidateExt3DetailList()
      }
      return true
    },
    handleValidateExt1And2DetailList() {
      // V3.6.2 ext1=1/2：行内必填含 shareTypeNo；同 tab 调整金额合计须为 0
      let errmsg = null
      const totalDetailList = (this.submitParms.detailList || [])
      for (let j = 0; j < totalDetailList.length; j++) {
        let adjustAmount = 0
        const detailList = totalDetailList[j]
        if (!Array.isArray(detailList)) {
          errmsg = '调整明细数据格式错误'
          this.$message({
                message: errmsg,
                type: "warning",
            });
          return false
        }
        for (let i = 0; i < detailList.length; i++) {
          if (String(detailList[i].adjustAmount) === '0' || String(detailList[i].adjustAmount) === 'null') {
            errmsg = "调整金额不允许为0"
          } else if (!detailList[i].adjustAmount) {
            errmsg = "调整金额不允许为空"
          }
          if (!detailList[i].cycleMonth) {
              errmsg = "缺少预算周期"
          }
          if (!detailList[i].shareTypeNo) {
              errmsg = "缺少是否待分摊"
          }
          if (!detailList[i].subjectsTypeId) {
              errmsg = "缺少预算类型"
          }
          if (!detailList[i].subjectsCatId) {
              errmsg = "缺少预算大类"
          }
          if (!detailList[i].firstDeptId) {
              errmsg = "缺少预算一级部门"
          }
          adjustAmount = plus(adjustAmount, detailList[i].adjustAmount || 0)
          if (String(this.submitParms.ext1) === '1') {
            const checkedName = this.budgetTypeList.find(item=> String(item.dicId) === String(detailList[i].subjectsCatId)).dicName
            if (errmsg) {
                const index = i + 1
                this.$message({
                    message: "预算调整明细" + checkedName + "第" + index + "行" + errmsg,
                    type: "warning",
                });
                return false;
            }
            
          } else if (String(this.submitParms.ext1) === '2') {
            const checkedName = this.firstDeptList.find(item=> String(item.dicId) === String(detailList[i].firstDeptId)).dicName
            if (errmsg) {
                const index = i + 1
                this.$message({
                    message: "预算调整明细" + checkedName + "第" + index + "行" + errmsg,
                    type: "warning",
                });
                return false;
            }
          }
        }
        const checkedName = this.budgetTypeList.find(item=> String(item.dicId) === String(detailList[0].subjectsCatId)).dicName
        console.log('adjustAmount', adjustAmount)
        if(adjustAmount !== 0) {
          this.$message({
              message: checkedName + "调整金额合计必须为0",
              type: "warning",
          });
          return false; 
        }
      }
      return true
    },
    // async queryListCount() { // 查询已调整次数
    // },
    /**
     * @description 发起月度资金计划调整
     */
    async submit() {
        // 前置选择了几个预算大类，则显示几个小表格，且预算大类自动带出，因为每个预算大类的调整金额合计必须为0
        // return
        await sleep(100);
        let errmsg = null
        
        // if (!this.submitParms.detailList || this.submitParms.detailList.length == 0) {
        //     errmsg = "请导入预算调整明细文件"
        // }
        if (this.submitParms.ext1 === '1' && (!Array.isArray(this.submitParms.budgetType) || this.submitParms.budgetType.length === 0)) {
          errmsg = "请选择预算大类"
        }
        if (this.submitParms.ext1 === '2' && (!Array.isArray(this.submitParms.deptCodeList) || this.submitParms.deptCodeList.length === 0)) {
          errmsg = "请选择预算一级部门"
        }
        // if (!this.submitParms.ext1) {
        //     errmsg = "请选择预算调整类型"
        // }
        // if (!this.submitParms.expectedCompletionDate) {
        //     errmsg = "请选择预算调整期待完成日期"
        // }
        if (!this.submitParms.ext1) {
            errmsg = "请选择预算调整类型"
        }
        if (['1', '3'].includes(String(this.submitParms.ext1))) {
            // V3.6.2：相同预算大类(1)、弹性授予(3) 已从前端入口隐藏，提交前二次拦截
            // 实际没有啥用，用户更新页面才会触发，但更新页面就选不到1、3
            errmsg = "当前预算调整类型不可用，请重新选择"
        }
        if (!this.submitParms.ext3) {
            errmsg = "请选择预算调整紧急程度"
        }
        if (!this.submitParms.title) {
            errmsg = "请输入流程标题"
        }
        if (errmsg) {
            this.$message({
                message: errmsg,
                type: "warning",
            });
            return;
        }
        if (!this.validateDetailList()) {
          return
        }
        if (String(this.submitParms.ext1) === '5' && (this.fileListStr === "[]" || !this.fileListStr)) {
          errmsg = "预算外调整附件必传"
        }
        if (errmsg) {
            this.$message({
                message: errmsg,
                type: "warning",
            });
            return;
        }
        const params = {
            ...this.submitParms,
            year: this.submitParms.alterYear,
            attachment: this.fileListStr,
        };
        if (String(this.submitParms.ext1) === '3') {
          params.grantDetail = (this.submitParms.detailList.flat() || []).map(item=>{
            return {
              ...item,
              grantedMonth: item.grantedMonth? item.grantedMonth.split('_')[0] + '年' + item.grantedMonth.split('_')[1] + '月' : null,
              pendingGrantedMonth: item.pendingGrantedMonth? item.pendingGrantedMonth.split('_')[0] + '年' + item.pendingGrantedMonth.split('_')[1] + '月' : null,
              year: this.submitParms.alterYear,
              id: null
            }
          })
          this.$delete(params, 'detailList')
        } else {
          // V3.6.2：提交 start.json 前补全 shareTypeNo/shareType，历史无值默认「否」
          params.detailList = this.submitParms.detailList.flat().map(function(item) {
            const shareTypeNo = item.shareTypeNo || defaultShareTypeNo
            return Object.assign({}, item, {
              shareTypeNo: shareTypeNo,
              shareType: item.shareType || getShareTypeLabel(shareTypeNo),
            })
          })
          this.$delete(params, 'grantDetail')
        }
        this.loading = true;
        const [, res] = await awaitWrapper(addYearAdjust(params));
        this.loading = false;
        if (res && res.code === 0) {
            this.$message({
            message: "发起调整成功",
            type: "success",
            });
            this.$router.push({
              name: 'myPedding'
            })
        }
    },
    
  },
};
</script>

<style scoped>
.submit {
  margin: 20px 0;
  text-align: center;
}
</style>